// Vocab del diagnóstico de preñez (Dx) — api-reference/admin-pregnancies.md (0013, 0028).
// Resultado del backend: positive|negative|doubtful|recheck|ppl. Mapeo a la
// nomenclatura del campo: P = Preñada (positive), V = Vacía (negative).
// PPL = preñada poco líquido (0028): preñada pero con poco líquido → recheck
// cercano; a efectos de flujo se comporta como doubtful/recheck (sin cambio de estado).

export const DX_RESULTS = [
    { value: 'positive', short: 'P',   label: 'Preñada', tone: 'good' },
    { value: 'ppl',      short: 'PPL', label: 'Preñada poco líquido', tone: 'warn' },
    { value: 'negative', short: 'V',   label: 'Vacía',   tone: 'bad' },
    { value: 'doubtful', short: '?',   label: 'Dudoso',  tone: 'warn' },
    { value: 'recheck',  short: 'R',   label: 'Repetir', tone: 'warn' },
];

// Lookup por token de resultado (para pintar el historial de dx ya registrados).
export const DX_RESULT_BY_VALUE = Object.fromEntries(DX_RESULTS.map((r) => [r.value, r]));

// Estado de la preñez (transiciones 0013): open → confirmed → lost | born.
export const PREG_STATE = {
    open:      { label: 'Abierta',    tone: 'open' },
    confirmed: { label: 'Confirmada', tone: 'good' },
    lost:      { label: 'Perdida',    tone: 'bad' },
    born:      { label: 'Nacida',     tone: 'good' },
};

// Solo open/confirmed admiten una palpación más (lost/born → 409).
export function isDiagnosable(state) {
    return state === 'open' || state === 'confirmed';
}

// Fases de dx (las más comunes). El flujo se divide: fase 1 = dx1, fase 2 = dx2.
export const DX_PHASES = [
    { value: 1, label: 'DX 1' },
    { value: 2, label: 'DX 2' },
];

// Clasifica qué se puede hacer con el dx `phase` (1|2) de una preñez, según su
// historial (`diagnostics`) y el puntero `next_dx` (0030/0031). Modos:
//   'register'  → POST: dxN aún no registrado y es el que toca (next_dx.number===N)
//   'edit'      → PATCH: dxN registrado y es el ÚLTIMO (0031: solo el último es editable)
//   'locked'    → dxN registrado pero congelado (ya hay un dx posterior) → solo lectura
//   'needs-prev'→ fase 2 sin dx1 (no se permite dx2 sin dx1)
//   'na'        → no aplica en esta fase (o detalle aún no cargado)
export function dxPhaseInfo(diagnostics, nextDx, phase) {
    const list = diagnostics || [];
    const dxN = list.find((d) => d.number === phase);
    const lastNum = list.reduce((m, d) => (d.result != null && d.number > m ? d.number : m), 0);

    if (phase === 2) {
        const dx1 = list.find((d) => d.number === 1);
        if (!(dx1 && dx1.result != null)) return { mode: 'needs-prev' };
    }
    if (dxN && dxN.result != null) {
        return { mode: dxN.number === lastNum ? 'edit' : 'locked', dxId: dxN.id, current: dxN.result };
    }
    if (nextDx && nextDx.number === phase) {
        return { mode: 'register', scheduledFor: nextDx.scheduled_for || null, kind: nextDx.kind || 'scheduled' };
    }
    return { mode: 'na' };
}

// Días entre dos fechas wall-clock 'YYYY-MM-DD' (b − a), TZ-safe (no transporte):
// se interpretan como medianoche UTC, así la resta da días enteros exactos.
export function daysBetween(a, b) {
    if (!a || !b) return null;
    const ms = Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`);
    return Number.isNaN(ms) ? null : Math.round(ms / 86400000);
}
